import { Box } from '@mui/material';
import { useParams } from 'react-router-dom';
import FolderModule from './FolderModule';
import FolderBreadcrumb from './FolderBreadcrumb';

const FolderServicePage = () => {
    const { serviceModuleId } = useParams<{ serviceModuleId }>();
    const folderId = Number(serviceModuleId)!
    return (
        <Box>
            <FolderBreadcrumb folderId={folderId} />
            <FolderModule folderId={folderId} />
        </Box>
    )
}

export default FolderServicePage